import React, { useState } from 'react';
import { Modal, Button, Input, Select } from '../../components/ds';
import api from '../../api/client';

const TIMEZONES = [
  'Asia/Taipei',
  'Asia/Tokyo',
  'Asia/Shanghai',
  'Asia/Hong_Kong',
  'Asia/Singapore',
  'Asia/Seoul',
  'America/New_York',
  'America/Los_Angeles',
  'Europe/London',
  'UTC',
];

export default function CreateAccountModal({ onClose, onCreated }) {
  const [form, setForm] = useState({
    account_name: '',
    timezone: 'Asia/Taipei',
    user_name: '',
    email: '',
    password: '',
  });
  const [features, setFeatures] = useState({
    targeting: {
      frequency_cap: true,
      day_parts: true,
      keywords: true,
      audience: false,
    },
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await api.createAccount(form);
      try {
        await api.updateAccountFeatures(data.accountID, features);
      } catch {
        // Features will use defaults if this fails
      }
      onCreated(data.accountID);
    } catch (err) {
      setError(err.message || 'Failed to create account');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal title="Create Account" onClose={onClose} footer={
      <>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Creating...' : 'Create'}
        </Button>
      </>
    }>
      <form onSubmit={handleSubmit}>
        <h3 style={{ marginBottom: 12, fontSize: 15, color: 'var(--text-secondary)' }}>
          Account Info
        </h3>

        <Input
          label="Account Name *"
          value={form.account_name}
          onChange={handleChange('account_name')}
          placeholder="Enter account name"
          required
        />

        <Select
          label="Timezone *"
          value={form.timezone}
          onChange={handleChange('timezone')}
          options={TIMEZONES.map((tz) => ({ value: tz, label: tz }))}
        />

        <h3 style={{ marginBottom: 12, marginTop: 24, fontSize: 15, color: 'var(--text-secondary)' }}>
          First Admin User
        </h3>

        <Input
          label="User Name *"
          value={form.user_name}
          onChange={handleChange('user_name')}
          placeholder="Enter user name"
          required
        />

        <Input
          label="Email *"
          type="email"
          value={form.email}
          onChange={handleChange('email')}
          placeholder="Enter email"
          required
        />

        <Input
          label="Password *"
          type="password"
          value={form.password}
          onChange={handleChange('password')}
          placeholder="Enter password"
          required
        />

        <h3 style={{ marginBottom: 12, marginTop: 24, fontSize: 15, color: 'var(--text-secondary)' }}>
          Feature Settings — Targeting
        </h3>

        {[
          { key: 'frequency_cap', label: 'Frequency Cap' },
          { key: 'day_parts', label: 'Day Parts' },
          { key: 'keywords', label: 'Keywords' },
          { key: 'audience', label: 'Audience' },
        ].map((opt) => (
          <label
            key={opt.key}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '8px 12px',
              borderRadius: 'var(--radius-md)',
              cursor: 'pointer',
              border: '1px solid var(--border-color)',
              marginBottom: 8,
              backgroundColor: features.targeting[opt.key] ? 'var(--bg-secondary)' : 'transparent',
            }}
          >
            <input
              type="checkbox"
              checked={features.targeting[opt.key] || false}
              onChange={() =>
                setFeatures((prev) => ({
                  ...prev,
                  targeting: {
                    ...prev.targeting,
                    [opt.key]: !prev.targeting[opt.key],
                  },
                }))
              }
              style={{ width: 18, height: 18 }}
            />
            <span style={{ fontWeight: 500 }}>{opt.label}</span>
          </label>
        ))}

        {error && <div className="error-text">{error}</div>}
      </form>
    </Modal>
  );
}
